import { JSX, useEffect, useState } from 'react';
import NoteContent from './noteContent';
import './note.css';
import NoteManager from '../todolist/data/noteManager';
import TitleInput from '../common/title/title';
import AddButton from '../common/AddButton/addButton';
import TodoManager from '../todolist/data/todoManager';
import { processNoteApi } from '../services/process-notes';
import { TodoTask } from '../todolist/add-todo/addTodoList';
import Loading from '../common/Loading/loading';
import NoteTodos from '../note-page/note-todos';

export interface NoteProps {
    _id?: string,
    id: number,
    title: string,
    date: Date,
    content: string
};

const Note = (): JSX.Element => {
    const noteManager = NoteManager.getInstance();
    const [newNote, setNote] = useState<NoteProps>(noteManager.getDraftNote());

    const [isLoading, setIsLoading] = useState(false);
    const [isNoteProcessed, setIsNoteProcessed] = useState(false);
    const [isNoteEdit, setIsNoteEdit] = useState(true);
    const [todos, setTodos] = useState<TodoTask[]>([]);

    const changeNoteTitle = (title: string) => {
        setNote({...newNote, title: title});
    }

    const changeNoteContent = (content: string) => {
        console.log(content);
        setNote({...newNote, content: content});
    }

    const changeNoteDate = (date: Date) => {
        setNote({...newNote, date: date});
    }

    useEffect(() => {
        noteManager.saveDraftNote(newNote);
    }, [newNote])

    
    const prcessNote = async (): Promise<void> => {
        setIsNoteEdit(false);
        setIsLoading(true);
        await noteManager.addNote(newNote);
        await processNotes(newNote);
        setIsLoading(false);
    };

    const processNotes = async (noteText: NoteProps) => {
        const newtodos = await processNoteApi.extractTodosFromNotes(noteText);
        setTodos(newtodos.todos);
        setIsNoteProcessed(true);
    };

    const addNote = () => {
        todos.forEach(task => {
            TodoManager.getInstance().addTodo(task);
        });

        setNote({
            id: Date.now(),
            title: "",
            date: new Date(),
            content: "",
        });

        setIsNoteProcessed(false);
    }

    const editTitle = (updatedTodo: TodoTask, newTitle: string) => {
        const updatedTodos = todos.map(todo => 
          todo.id === updatedTodo.id ? {...todo, title: newTitle} : todo
        );
        setTodos(updatedTodos);
    };

    const deleteTodo = (todoToDelete: TodoTask) => {
        const updatedTodos = todos.filter(todo => todo.id !== todoToDelete.id);
        setTodos(updatedTodos);
    };

    const addTodo = (todo: TodoTask) => {
        if (todo.title != "")
            setTodos([...todos, todo]);
    }

    return (
        <div className='note-container'>
            {/* Title */}
            <TitleInput title={newNote.title} setTitle={changeNoteTitle}/>
            <NoteContent noteContent={newNote.content} noteDate={newNote.date} onContentChange={changeNoteContent} onDateChange={changeNoteDate} editMode={isNoteEdit} onFocus={() => setIsNoteEdit(true)}/>
            {/* Add Button */}
            <AddButton title='Process' addFunction={prcessNote}/>
            {isNoteProcessed ? (
                <div>
                    <NoteTodos note={newNote} todos={todos} editTitle={editTitle} deleteTodo={deleteTodo} saveTodo={addTodo}/> 
                    <AddButton title='Add' addFunction={addNote}/>
                </div>
                ) : (
                <></>
            )}
            {isLoading? (<Loading/>):(<></>)}
        </div>
    ); 
  };
    
  export default Note;